import { AVAILABLE_COLUMNS } from './columns'
import * as common from 'store/modules/common/filters'
import { staticFilterPage } from 'enums/staticFilterPage'

export const initialState = {
  ...common.initialState(staticFilterPage.bottles)
}
const PREFIX = 'bottlesFilter'

export const actionTypes = {
  ...common.actionTypes(PREFIX)
}

export const actionCreators = {
  ...common.actionCreators(PREFIX)
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    default: return common.reducer(state, action, PREFIX, AVAILABLE_COLUMNS)
  }
}
